<template>
  <div class="fop-form">
    <INNInput isFopFormParent :firm-info="formData.legalPersonInfo"/>
    <div class="user-logged-form__item" v-if="formData.legalPersonInfo.full_name">
      <label class="typo__label">{{ $t('payer_name') }}</label>
      <input type="text"
             class="control"
             disabled
             :value="formData.legalPersonInfo.full_name">
    </div>
  </div>
</template>

<script>
import INNInput from './INNInput'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'FOPForm',
  components: { INNInput },
  computed: {
    ...mapState({
      formData: state => state.checkout.formData
    })
  },
  methods: mapActions(['SET_FORM_DATA'])
}
</script>

<style lang="sass" scoped>
.fop-form
  margin-bottom: 15px
</style>
